module.exports = __webpack_public_path__ + "img/arrow-neera-green.53051bc4.svg";